// extracted by mini-css-extract-plugin
export default {"button":"Catagories_button__+udmH","catagories":"Catagories_catagories__tosj+"};